import { render, staticRenderFns } from "./AffiliateConfirm.vue?vue&type=template&id=75c34f6c&"
import script from "./AffiliateConfirm.vue?vue&type=script&lang=js&"
export * from "./AffiliateConfirm.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateConfirm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports